import { Button } from '@heroui/button'
import { Modal, ModalBody, ModalContent } from '@heroui/modal'

import { Comment2AiIcon } from '@/components/shared/icons'
import { Typography } from '@/components/ui/typography'

interface AlmiWelcomeModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

const AlmiWelcomeModal = ({ isOpen, onOpenChange }: AlmiWelcomeModalProps) => {
  return (
    <Modal
      placement="center"
      size="sm"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      hideCloseButton
      classNames={{
        base: 'mx-6',
        body: 'items-center gap-8 py-8 px-6',
      }}
    >
      <ModalContent>
        {(onClose) => (
          <ModalBody>
            <div className="flex flex-col items-center">
              <Comment2AiIcon className="mb-3 text-[56px]" />
              <Typography
                size="2xlarge"
                weight="regular"
                className="mb-4 text-center font-crimsonPro text-foreground"
              >
                Welcome to Almi, <br /> Your AI Therapist
              </Typography>
              <Typography
                size="xsmall"
                className="text-center text-content4-foreground"
                weight="regular"
              >
                Meet Almi, your AI companion here to support your mental
                well-being. While Almi offers helpful insights, please remember
                that it may make mistakes and is not a substitute for
                professional medical support.
                <br />
                <br /> If you need assistance or support, we strongly encourage
                you to reach out to a licensed therapist.
              </Typography>
            </div>
            <Button
              size="lg"
              variant="faded"
              color="primary"
              fullWidth
              className="rounded-[80px]"
              onClick={onClose}
            >
              Continue
            </Button>
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  )
}

export default AlmiWelcomeModal
